import type { MeasureDateRange } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import { pluralize } from "@entrilia/shared/utilities/stringHelper.ts";
import type { ReportField } from "../../../../../../../../api/types/svTypes.ts";
import { ranges } from "../../../../utilities/dateRangeToShortString.ts";
import { getMeasureRanges } from "../../utils/dateRangeToString.ts";

export const INHERIT_PERIOD = "Inherit";

export type LinePeriodValue = MeasureDateRange | typeof INHERIT_PERIOD;

export interface LinePeriodOption {
  value: LinePeriodValue;
  label: string;
}

export const getRangeText = (range: MeasureDateRange): string =>
  ranges.find((option) => option.value === range)?.text ?? range;

export const getPeriodOptions = (inheritLabel: string): LinePeriodOption[] => [
  { value: INHERIT_PERIOD, label: inheritLabel },
  ...getMeasureRanges().map((range) => ({ value: range.value, label: `${range.text} (${range.short})` })),
];

export const getFieldConditionCount = (field: Pick<ReportField, "config">): number =>
  (field.config.customConditions?.length ?? 0) + (field.config.linkedConditions?.length ?? 0);

export const getConditionsTooltip = (conditionCount: number): string =>
  conditionCount === 0 ? "Conditions" : `${conditionCount} ${pluralize("condition", conditionCount)}`;
